import { render } from "./Hall5En.vue?vue&type=template&id=556c4eb0"
import script from "./Hall5En.vue?vue&type=script&lang=js"
export * from "./Hall5En.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__